export { default } from './index.vue';


// WEBPACK FOOTER //
// ./packages/wxc-checkbox-list/index.js